import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  input,
  output,
  viewChildren,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NgbPaginationModule,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';

export interface TableColumnSetting {
  mapDataCol: string;
  text: string;
  display: boolean;
}

export type TableData = Array<object>;

export interface Table {
  entity?: string;
  columnSettings: TableColumnSetting[];
  primaryKey: string;
  data: TableData;
}

@Component({
  selector: 'app-ngb-table',
  templateUrl: './ngb-table.component.html',
  styleUrls: ['./ngb-table.component.css'],
  imports: [CommonModule, NgbPaginationModule, NgbDropdownModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgbTableComponent implements OnInit, OnChanges {
  readonly table = input<Table>();
  readonly showActionButtons = input<boolean>();
  readonly showModalButton = input<boolean>();
  readonly showFooter = input<boolean>();
  readonly scrollX = input(false);
  readonly scrollY = input(true);

  readonly deleteDatarow = output<{ id: string; entity: string }>();
  readonly restoreDatarow = output<{ id: string; entity: string }>();
  readonly updateDatarow = output<{
    id: string;
    entity: string;
    updatedData: object;
  }>();
  readonly showModal = output<{ id: string; entity: string }>();
  private readonly dataInputElements = viewChildren<ElementRef>('dataInput');

  bEditId: string = null;

  tableDisplay: TableData = [];
  page = 1;
  pageSize = 20;
  maxSize = 10;

  ngOnInit(): void {
    if (this.table()) this.updatePageCollection(this.page);
  }

  ngOnChanges(): void {
    this.bEditId = null;
    this.page = 1;
    if (this.table()) this.updatePageCollection(this.page);
  }

  set pSize(pageSize: number) {
    this.pageSize = pageSize;
    this.updatePageCollection(1);
  }

  originalOrder = (): number => {
    return 0;
  };

  updatePageCollection(pageSelected: number): void {
    const firstIndex = pageSelected * this.pageSize - this.pageSize;
    const table = this.table();
    if (table) {
      this.tableDisplay = table.data.slice(
        firstIndex,
        firstIndex + this.pageSize,
      );
    }
  }

  onEdit(id: string): void {
    this.bEditId = id;
  }

  onCancel(): void {
    this.bEditId = null;
  }

  onSave(id: string): void {
    const updatedEntity = {
      _id: id,
    };

    this.dataInputElements().forEach(element => {
      const key = element.nativeElement.parentElement.id;
      const value = element.nativeElement.value;
      updatedEntity[key] = value;
    });

    this.bEditId = null;
    this.updateDatarow.emit({
      id,
      entity: this.table().entity,
      updatedData: updatedEntity,
    });
  }

  onDelete(id: string): void {
    this.deleteDatarow.emit({ id, entity: this.table().entity });
  }

  onRestore(id: string): void {
    this.restoreDatarow.emit({ id, entity: this.table().entity });
  }

  onShowModal(id: string): void {
    this.showModal.emit({ id, entity: this.table().entity });
  }
}
